import { Permission } from '../FeatureManagement/permission.enum';
import { TenantGroupPermission } from './tenant-group-permission.model';

export class TenantGroupPermissionDto {
    public GroupId: string;
    public GroupName: string;
    public TenantGroupName: string;
    public Permission: Permission;

    constructor(tenantGroup: TenantGroupPermission) {
        this.GroupId = tenantGroup.groupId;
        this.GroupName = tenantGroup.groupName;
        this.TenantGroupName = tenantGroup.tenantGroupName;
        this.Permission = tenantGroup.hasPermission ? Permission.Allow : Permission.Deny;
    }
}